import React, { useState, useEffect } from "react";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUserCircle, faCaretDown } from "@fortawesome/free-solid-svg-icons"; // Added caret-down icon
import { Outlet, useNavigate } from "react-router-dom";
import logo from './Images/passionit.png'; // Ensure this path is correct
import { Link } from "react-router-dom";
import { jwtDecode } from 'jwt-decode';
import EditProfile from '../UserCommon/editprofile';

const User = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState('');
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [masterDropdownOpen, setMasterDropdownOpen] = useState(false); // state for Master dropdown
  const navigate = useNavigate();
  const [showEditProfile, setShowEditProfile] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const userId = parseInt(decoded.id, 10);
      setUserId(userId);
      localStorage.setItem("id", userId);
      setEmail(decoded.email);
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
    localStorage.removeItem("id");
    navigate("/login");
  };

  const handleProfileClick = () => {
    setProfileMenuOpen(!profileMenuOpen); 
  }; 

  const handleMasterDropdownToggle = () => {
    setMasterDropdownOpen(!masterDropdownOpen); 
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-menu")) {
        setProfileMenuOpen(false);
      }
      if (!e.target.closest(".master-dropdown")) {
        setMasterDropdownOpen(false); 
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <>
      <div className="sticky top-0 bg-[#e64a32] z-50 py-4">
        <nav>
          <div className="mx-auto max-w-7xl">
            <div className="flex justify-between items-center mx-auto w-full">
              {/* Logo on the left */}
              <Link to="/" className="flex items-center mr-8">
                <img src={logo} alt="Passion IT Logo" className="h-[40px] w-[100px]" />
              </Link>

              <div className="hidden gap-10 lg:flex justify-between w-full"> 
                <Link to="/" className="mr-2 text-white">Home</Link>
                {/* Play DB Button */}
                <Link to="/playdbtable" className="mr-2 text-white">Play Game</Link> 

                {/* Master Dropdown Menu */}
                <div className="relative master-dropdown order-1">
                  <button
                    onClick={handleMasterDropdownToggle}
                    className="text-white mr-6 flex items-center gap-2"
                  >
                    Master
                    <FontAwesomeIcon
                      icon={faCaretDown} // Dropdown arrow icon
                      className={`transition-transform ${masterDropdownOpen ? 'rotate-180' : ''}`}
                    />
                  </button>
                  {masterDropdownOpen && (
                    <div className="absolute bg-white text-gray-800 shadow-lg rounded-md mt-2 w-48 z-50">
                      <Link to="/categorytable" className="block px-4 py-2">Game Category</Link>
                      <Link to="/cardgrouptable" className="block px-4 py-2">Card Group</Link>
                      <Link to="/cardtable" className="block px-4 py-2">Card</Link>
                      <Link to="/gamemastertable" className="block px-4 py-2">Game Master</Link>
                      <Link to="/cardalloctable" className="block px-4 py-2">Game Card Allocation</Link>
                      <Link to="/networktable" className="block px-4 py-2">Network Management</Link>
                      <Link to="/history" className="block px-4 py-2">Game History</Link>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-4">
          <div className="flex items-center lg:hidden">
            <button onClick={() => setToggleMenu(!toggleMenu)}>
              <Bars3Icon className="h-6" />
            </button>
          </div>
          {isLoggedIn && (
  <div className="relative flex items-center profile-menu order-2">
    <button
      onClick={handleProfileClick} // Only toggles dropdown
      className="flex items-center text-white hover:text-gray-300 focus:outline-none"
    >
      <FontAwesomeIcon icon={faUserCircle} className="h-6" />
      <span className="ml-4 text-white">Profile</span>
    </button>
    {profileMenuOpen && (
  <div className="absolute right-0 mt-2 bg-white rounded-md shadow-lg z-50 w-78">
    <div className="px-4 py-2 text-gray-600">
      <p className="font-semibold">Profile</p>
      <p className="text-gray-600">{email}</p>
      
      {/* Edit Profile Button */}
            <div className="text-gray-800 hover:bg-gray-200">
            <Link to="/editprofile" className="block px-4 py-2">Edit Profile</Link></div>

      {/* Log Out Button */}
      <button
        onClick={handleLogout}
        className="mt-2 w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-200"
      >
        <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
        Log Out
      </button>
        </div>
      </div>
    )}
  </div>
)}
        </div>
            </div>
          </div>
        </nav>
      </div>

      {toggleMenu && (
        <div className="flex flex-col items-center gap-4 mt-4 lg:hidden">
          <Link to="/" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Home</Link>
          <Link to="/playdbtable" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Play DB</Link> {/* Play DB for mobile */}
          <Link to="/cardgrouptable" className="mr-2 text-white" onClick={() => setToggleMenu(false)}>Card Group</Link>
          <Link to="/cardtable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Card</Link>
          <Link to="/categorytable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Category</Link>
          <Link to="/gamemastertable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Master</Link>
          <Link to="/cardalloctable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game Card Allocation</Link>
          <Link to="/networktable" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Network Management</Link>
          <Link to="/history" className="mr-6 text-white" onClick={() => setToggleMenu(false)}>Game History</Link>
  
        </div>
      )}

      <div className="py-10 px-2">
        <Outlet />
      </div>
    </>
  );
};

export default User;
